import React from 'react'
import { Navbar, Nav, Dropdown, NavLink } from 'react-bootstrap'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import {useLogoutMutation, useLogoutAllMutation, useGetMeQuery} from '../store/api'
import useHasPermission from '../hooks/useHasPermission'

const Header: React.FC = () => {
	const navigate = useNavigate()
	const location = useLocation()
	const {data} = useGetMeQuery()
	const [logout] = useLogoutMutation()
	const [logoutAll] = useLogoutAllMutation()
	const hasRulesIndexPermission = useHasPermission('rules.index')

	const handleLogout = async () => {
		try {
			await logout().unwrap()
		} catch (error) {
			console.log(error)
		} finally {
			navigate('/login')
		}
	}

	const handleLogoutAll = async () => {
		try {
			await logoutAll().unwrap()
		} catch (error) {
			console.log(error)
		} finally {
			navigate('/login')
		}
	}
	return (
		<Navbar bg="dark" variant="dark" expand="lg" className="mb-4">
			<div className="container-fluid d-flex justify-content-between align-items-center">
				<Navbar.Brand as={Link} to="/invoices" style={{ color: '#443ed1' }}>
                    Invoice Processing
				</Navbar.Brand>
				<Nav className="d-flex w-100 justify-content-start align-items-center">
					<NavLink
						as={Link}
						to="/invoices"
						active={location.pathname === '/invoices'}
					>
							Інвойси
					</NavLink>
					{hasRulesIndexPermission && (
						<NavLink
							as={Link}
							to="/categories"
							active={location.pathname === '/categories'}
						>
								Категорії
						</NavLink>
					)}
				</Nav>
				<Nav>
					{data && (
						<Dropdown>
							<Dropdown.Toggle variant="outline-light" id="dropdown-basic">
								{data.user.name} ({data.user.email})
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item onClick={handleLogout}>
										Вийти
								</Dropdown.Item>
								<Dropdown.Item onClick={handleLogoutAll}>
										Вийти з усіх пристроїв
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					)}
				</Nav>
			</div>
		</Navbar>
	)
}

export default Header
